import cx from 'classnames';
import { SVGProps } from 'react';

export const TeamInsightsIcon = ({
  className,
  ...rest
}: SVGProps<SVGSVGElement>) => (
  <svg
    className={cx(className, 'ethena-icon')}
    stroke="currentColor"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M16.5076 5.16667C17.6582 5.16667 18.5909 4.23393 18.5909 3.08333C18.5909 1.93274 17.6582 1 16.5076 1C15.357 1 14.4242 1.93274 14.4242 3.08333C14.4242 4.23393 15.357 5.16667 16.5076 5.16667Z"
      fill="#000"
      fillOpacity="0.12"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5076 12.1742C17.6582 12.1742 18.5909 11.2414 18.5909 10.0908C18.5909 8.94025 17.6582 8.00751 16.5076 8.00751C15.357 8.00751 14.4242 8.94025 14.4242 10.0908C14.4242 11.2414 15.357 12.1742 16.5076 12.1742Z"
      fill="#000"
      fillOpacity="0.12"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.58333 12.1742C4.73393 12.1742 5.66667 11.2414 5.66667 10.0908C5.66667 8.94025 4.73393 8.00751 3.58333 8.00751C2.43274 8.00751 1.5 8.94025 1.5 10.0908C1.5 11.2414 2.43274 12.1742 3.58333 12.1742Z"
      fill="#000"
      fillOpacity="0.12"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5076 19.1848C17.6582 19.1848 18.5909 18.2521 18.5909 17.1015C18.5909 15.9509 17.6582 15.0181 16.5076 15.0181C15.357 15.0181 14.4242 15.9509 14.4242 17.1015C14.4242 18.2521 15.357 19.1848 16.5076 19.1848Z"
      fill="#000"
      fillOpacity="0.12"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 10.0909H10.1941M14.3219 10.0909H10.1941M10.1941 10.0909V5.54542C10.1941 4.54126 11.0082 3.72723 12.0123 3.72723H14.7273M10.1941 10.0909V14.6363C10.1941 15.6405 11.0082 16.4545 12.0123 16.4545H14.7273"
      strokeWidth="1.67"
    />
  </svg>
);
